import React, { useEffect } from 'react';
import { ItemAdder } from './character-sheet/abilities-equipment/item-adder';
import { CharacterSheetComponent } from './character-sheet/CharacterSheet';
import { useParams } from 'react-router';
import { Loader } from '../../theming/loader/Loader';
import { useAppDispatch, useAppSelector } from '../../../store/configureStore';
import { AddItemSlotsRequest } from '../../../apis/requests/AddItemSlotsRequest';
import { ModSlot } from '../../../entities/library/items/mods/ModSlot';
import { CharacterItemActions } from '../../../store/stores/collection/characters/actions/CharacterItemActions';
import { AddSlotChangeRequest, IsAddSlotChangeRequest, IsRemoveSlotChangeRequest, RemoveSlotChangeRequest, SkillHelpers } from '../../../entities/library/skills/Skill';
import { CharacterSpecificActions } from '../../../store/stores/collection/characters/actions/CharacterSpecificActions';
import { AdventureActions } from '../../../store/stores/adventures/AdventureStore.Actions';

export const CharacterComponent: React.FC = () => {
    const dispatch = useAppDispatch();
    const { characters, loaded } = useAppSelector(app => app.character);
    const { adventures, loaded: adventuresLoaded } = useAppSelector(app => app.adventure);
    const library = useAppSelector(app => app.library);
    const params = useParams();

    const id = params["id" as keyof typeof params];
    const invalidId = id == null || id == '';
    const character = characters.find(c => c.id == id);

    let addChanges: AddItemSlotsRequest[] = [];
    let removeChanges: ModSlot[] = [];

    useEffect(() => {
        if (!adventuresLoaded) {
            dispatch(AdventureActions.getAdventures());
        }
    }, [adventuresLoaded]);

    useEffect(() => {
        if (character == null) {
            return;
        }
        const pendingSlotChanges = character.skills
            .mapMany(reference => {
                const skill = library.skills.find(s => s.id == reference.id);
                if (skill == null) {
                    return [];
                }
                return SkillHelpers.getSlotChangesOnLoad(skill, character, library.items)});

        addChanges = pendingSlotChanges
            .filter<AddSlotChangeRequest>(IsAddSlotChangeRequest)
            .mapMany(request => request.changes);
        if (addChanges.any()) {
            dispatch(CharacterItemActions.addSlots(character, addChanges));
        }
        
        removeChanges = pendingSlotChanges
            .filter<RemoveSlotChangeRequest>(IsRemoveSlotChangeRequest)
            .mapMany(request => request.changes);
        if (removeChanges.any()) {
            dispatch(CharacterItemActions.removeSlots(character, removeChanges));
        }
    }, [dispatch, character]);

    if (!loaded || character == null) {
        return <Loader size="XL">Loading Character...</Loader>;
    }

    return (
        <>
            <CharacterSheetComponent character={character} />
            <ItemAdder character={character} visible={character.showItemAdder} close={() => dispatch(CharacterSpecificActions.hideItemAdder(character))} />
        </>
    )
}